import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { loadingPonBoxDataComponent, loadingFobDataComponent, loadingDividerDataComponent, loadingCassetteDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { WritePonBoxNode, WriteFobNode, WriteDividerNode, WriteCassetteNode } from '../../../WriteData/WriteHighwayCommunications';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { GET_CITY_API_URL } from '../../../OpticApiConfig';
import { CONST_HIGHWAY } from '../../../Constants/ConstantsOptics';
import Select from 'react-select';
import { UpdateDividerKtvComponents, UpdateDividerPonComponents } from '../../../UpdateData/UpdateStatusComponent';


const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px',
  }),
  menuList: base => ({
    ...base,
    maxHeight: '200px', // Ограничение высоты меню для отображения 5 пунктов
    overflowY: 'auto' // Включает скролл, если пунктов больше 5
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};


const PonBoxEditingDialogNode = ({ open, onClose, latitude, longitude, canton, area, user, cantonRefresh, hid, entrance, flag}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

 const commentTextAreaRefPonBox = useRef(null);
 const commentTextAreaRefFob = useRef(null);
 const commentTextAreaRefDivider = useRef(null);
 const commentTextAreaRefCassette = useRef(null);

  const [commentPonBox, setCommentPonBox] = useState('');
  const [commentFob, setCommentFob] = useState('');
  const [commentCassette, setCommentCassette] = useState('');
  const [commentDivider, setCommentDivider] = useState('');
  const [ponboxData, setPonBoxData] = useState([]);
  const [fobData, setFobData] = useState([]);
  const [dividerData, setDividerData] = useState([]);
  const [selectedDivired, setSelectedDivired] = useState(null);
  const [selectedFob, setSelectedFob] = useState(null);
  const [selectedPonBox, setSelectedPonBox] = useState(null);
  const [isVisiblePonBox, setIsVisiblePonBox] = useState(false);
  const [isVisibleFob, setIsVisibleFob] = useState(false);
  const [isVisibleDivider, setIsVisibleDivider] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [cassetteData, setCassetteData] = useState([]);
  const [isVisibleCassette, setIsVisibleCassette] = useState(false);
  const [selectedCassette, setSelectedCassette] = useState(null);
  const [statusPon, setStatusPon] = useState(false); 
  const [statusKtv, setStatusKtv] = useState(false); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ponBox, fob, divider, cassette] = await Promise.all([
          loadingPonBoxDataComponent(),
          loadingFobDataComponent(),
          loadingDividerDataComponent(),
          loadingCassetteDataComponent()
        ]);
        setPonBoxData(ponBox);
        setFobData(fob);
        setDividerData(divider);
        setCassetteData(cassette);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
  
    fetchData();
  }, []);

       

      

  const handleChangePonBox = (event) => {
    const selectedPonBox = event.target.value;
    setSelectedPonBox(selectedPonBox);
  };
  
  const handleCommentChangePonBox = (event) => {
    setCommentPonBox(event.target.value);
  }

  const handleChangeFob = (event) => {
    const selectedFob = event.target.value;
    setSelectedFob(selectedFob);
  };

  const handleChangeCassette = (event) => {
    const selectedCassette = event.target.value;
    setSelectedCassette(selectedCassette);
  };

  const handleChangeDivired = (selectedOption) => {
    if (!selectedOption) {
      return;
    }
    const selectedDivider = selectedOption.value; 
    setSelectedDivired(selectedDivider);
    
  };
  
  const handleCommentChangeFob = (event) => {
    setCommentFob(event.target.value);
  }

  const handleCommentChangeCassette = (event) => {
    setCommentCassette(event.target.value);
  }

  const handleCommentChangeDivider = (event) => {
    setCommentDivider(event.target.value);
  }
  
  async function ponBoxSave(event) {
      WritePonBoxNode(event, latitude, longitude, selectedPonBox, commentTextAreaRefPonBox, canton, area, 
        setCommentPonBox,cantonRefresh,setSelectedPonBox, user, hid, entrance, showSnackbar);
  }

  async function fobSave(event) {
    WriteFobNode(event, latitude, longitude, selectedFob, commentTextAreaRefFob, canton, area, 
      setCommentFob,cantonRefresh, setSelectedFob, user,  hid, entrance,  showSnackbar);
  }


  async function dividerSave(event) {
      WriteDividerNode(event, selectedDivired, cantonRefresh, setSelectedDivired,  hid, entrance, showSnackbar,commentTextAreaRefDivider, setCommentDivider, 
          statusPon, statusKtv, setStatusPon, setStatusKtv);
  }

  async function cassetteSave(event) {
    WriteCassetteNode(event, selectedCassette, cantonRefresh, setSelectedCassette,  hid, entrance, showSnackbar,commentTextAreaRefCassette, setCommentCassette);
  }

   const handlePonCheckboxChange = () => {
          setStatusPon(!statusPon);
   }

   const handleKtvCheckboxChange = () => {
          setStatusKtv(!statusKtv);
   }

  function toggleVisibilityPonBox() {
    setIsVisiblePonBox(!isVisiblePonBox);
  }

  function toggleVisibilityFob() {
    setIsVisibleFob(!isVisibleFob);
  }

  function toggleVisibilityDivider() {
    setIsVisibleDivider(!isVisibleDivider);
  }

  function toggleVisibilityCassette() {
    setIsVisibleCassette(!isVisibleCassette);
  }

  const handleCloseModal = () => {
    setCommentPonBox('');
    setCommentFob('');
    setCommentDivider('');
    setCommentCassette('');
    setSelectedFob(null);
    setSelectedPonBox(null);
    setSelectedCassette(null);
    setSelectedDivired(null);
    setIsVisiblePonBox(false);
    setIsVisibleFob(false);
    setIsVisibleDivider(false);
    setIsVisibleCassette(false);
    onClose();
  };

  const options = dividerData.map(divider => ({
    value: `${divider.id}`,
    label: divider.model,
    group: divider.polishingId === 1 ? "UPC" : "APC",
  }));

  // Группировка опций
  const groupedOptions = [
    {
      label: "UPC",
      options: options.filter(option => option.group === "UPC"),
    },
    {
      label: "APC",
      options: options.filter(option => option.group === "APC"),
    },
  ];

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
        <>
      <div>
      <button onClick={toggleVisibilityPonBox} className={isVisiblePonBox ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisiblePonBox ? 'Пон-бокс: скрыть' : 'Пон-бокс: показать'}
    </button>
        {isVisiblePonBox && (    
      <div className='divСommunicationsDrawer'>
       
       <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
      
      <label className='textTitleDrawer' style={{color: '#d6d6d6ff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)'}}>Пон-бокс</label>
      <hr className="horizontalLineDrawer" />
      <div>
       <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangePonBox} value={selectedPonBox}>
          <option value="null">Выберите пон-бокс</option>
          {ponboxData.map(fob => (
            <option key={fob.id} value={fob.id}>{fob.name}</option>
          ))}
        </select>
       
        <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />          

      </div>
      <div >

        <textarea
          className='areaDescriptionDrawer'
          style={{marginInlineEnd: "10px"}}
          placeholder="Комментарий"
          rows={3}
          cols={44}
          value={commentPonBox}
          ref={commentTextAreaRefPonBox}
          onChange={handleCommentChangePonBox}
        />
        <br/>
        <button onClick={ponBoxSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
      </div>
    </div>
        )}
    </div>


     {/* FOB */}   
    <div>
      <button onClick={toggleVisibilityFob} className={isVisibleFob ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleFob ? 'Фоб: скрыть' : 'Фоб: показать'}
     </button>
        {isVisibleFob && (    
      <div className='divСommunicationsDrawer'>
      <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
       <label className='textTitleDrawer' style={{color: '#d6d6d6ff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)'}}>Фоб</label>
       <hr className="horizontalLineDrawer" />
       <div>
        <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeFob} value={selectedFob}>
           <option value="null">Выберите фоб</option>
           {fobData.map(fob => (
             <option key={fob.id} value={fob.id}>{fob.name}</option>
           ))}
         </select>
         <br/>

       </div>
       <div >

         <textarea
           className='areaDescriptionDrawer'
           placeholder="Комментарий"
           style={{marginInlineEnd: "10px"}}
           rows={3}
           cols={44}
           value={commentFob}
           ref={commentTextAreaRefFob}
           onChange={handleCommentChangeFob}
         />
          <hr className="horizontalLineDrawer" />

         <button onClick={fobSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
       </div>
     </div>
        )}
    </div>

     {/* DIVIDER */}   
     <div>
      <button onClick={toggleVisibilityDivider} className={isVisibleDivider ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleDivider ? 'Делитель: скрыть' : 'Делитель: показать'}
     </button>
        {isVisibleDivider && (    
      <div className='divСommunicationsDrawer'>
      <img src='./divider_upc2.png' width='30' height='30' style={{ marginRight: "5px" }} />
       <label className='textTitleDrawer' style={{color: '#d6d6d6ff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)'}}>Делитель</label>
       <hr className="horizontalLineDrawer" />
       <div>
       <Select
                  className="selectSearchDrawer"
                  options={groupedOptions}
                  inputValue={inputValue}
                  styles={customStyles}
                  value={options.find(option => `${option.value}` === `${selectedDivired}`) || null} 
                  onInputChange={value => setInputValue(value)} 
                  onChange={handleChangeDivired}
                  placeholder="Выберите делитель"
                  isClearable
                />
         <hr className='horizontalLineDialog'/>
      

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label className='textTitleDrawer' style={{ color: '#d6d6d6ff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)'}}>Признак:</label>
              <label style={{ color: '#adc3ffff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)', marginLeft:'10px'}}>PON:</label>
                <input
                  type="checkbox"
                  checked={statusPon}
                  onChange={handlePonCheckboxChange}
                  style={{ marginLeft: '10px' }}
                />      

              <label style={{color: '#cbffadff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)', marginLeft:'10px'}}>KTV:</label>
                  <input
                    type="checkbox"
                    checked={statusKtv}
                    onChange={handleKtvCheckboxChange}
                    style={{ marginLeft: '10px' }}
                  />  
          </div>    
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

       </div>
       <div >
        
          <textarea
           className='areaDescriptionDrawer'
           placeholder="Комментарий"
           style={{marginInlineEnd: "10px"}}
           rows={3}
           cols={44}
           value={commentDivider}
           ref={commentTextAreaRefDivider}
           onChange={handleCommentChangeDivider}
         />
          <hr className="horizontalLineDrawer" />
         <button onClick={dividerSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
       </div>
     </div>
        )}
    </div>

     {/* CASSETTE */}   
     <div>
      <button onClick={toggleVisibilityCassette} className={isVisibleCassette ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleCassette ? 'Кассета: скрыть' : 'Кассета: показать'}
     </button>
        {isVisibleCassette && (    
      <div className='divСommunicationsDrawer'>
      <img src='./cassette.png' width='40' height='40' style={{ marginRight: "5px" }} />
       <label className='textTitleDrawer' style={{color: '#d6d6d6ff', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)'}}>Сплайс-кассета</label>
       <hr className="horizontalLineDrawer" />
       <div>
        <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeCassette} value={selectedCassette}>
           <option value="null">Выберите кассету</option>
           {cassetteData.map(cassette => (
             <option key={cassette.id} value={cassette.id}>{cassette.model}</option>
           ))}
         </select>
         <br/>

       </div>
       <div >

         <textarea
           className='areaDescriptionDrawer'
           placeholder="Комментарий"
           style={{marginInlineEnd: "10px"}}
           rows={3}
           cols={44}
           value={commentCassette}
           ref={commentTextAreaRefCassette}
           onChange={handleCommentChangeCassette}
         />
          <hr className="horizontalLineDrawer" />

         <button onClick={cassetteSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
       </div>
     </div>
        )}
    </div>
        </>

    
      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

        {/* <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={PON_BOX}
          flag={PON_BOX_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        /> */}

       {/* Snackbar */}
        <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      /> 
 {/*
      <DialogPonBoxConnectionComponent
          id={content.id}
          open={openModalConnection}
          onClose={() => setOpenModalConnection(false)}
          user={user}
      /> */}
    </Dialog>

    
  );
}

export default PonBoxEditingDialogNode;